import React from 'react'

import { HouseStudyDayGlobalCapacityFields } from './components/capacity-field/HouseStudyDayGlobalCapacityFields'
import { HouseStudyDayGlobalSeasonalPricesFields } from './components/seasonal-prices-fields/HouseStudyDayGlobalSeasonalPricesFields'
import { HouseStudyDayGlobalVatField } from './components/vat-field/HouseStudyDayGlobalVatField'
import { HouseStudyDayGlobalFieldProps } from '../form-container/HouseStudyDayGlobalFormContainer'
import { Divider } from '../../../../../../../atoms/divider/Divider'

export const HouseStudyDayGlobalOptionsFields = ({
  currencyArea,
  ...fieldProps
}: HouseStudyDayGlobalFieldProps) => {
  return (
    <>
      <Divider />

      <HouseStudyDayGlobalCapacityFields {...fieldProps} />

      <Divider />

      <HouseStudyDayGlobalSeasonalPricesFields
        {...fieldProps}
        currencyArea={currencyArea}
      />

      <Divider />

      <HouseStudyDayGlobalVatField
        {...fieldProps}
        currencyArea={currencyArea}
      />
    </>
  )
}
